import { useStore } from '../lib/store.ts';
import { app } from '../state/app.ts';
import { dismiss, toasts } from '../state/toast.ts';
import { Icon } from './Icon.tsx';

// Meldingen: onderin op de desktop; op de telefoon bovenin onder de balk (onderin staan de
// navigatie, de instructiebalk of het toetsenbord), breed genoeg voor een regel tekst met knop.

export function Toasts() {
  const list = useStore(toasts);
  const narrow = useStore(app, (s) => s.narrow);
  if (!list.length) return null;
  const tones = { info: 'bg-bar text-white', ok: 'bg-green text-white', warn: 'bg-amber text-white', error: 'bg-red text-white' };
  return (
    <div className={`fixed left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2 items-center pointer-events-none ${narrow ? 'top-[calc(var(--safe-top)+56px)] w-[calc(100%-24px)]' : 'bottom-4'}`} aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={`pointer-events-auto flex items-center gap-3 rounded-lg px-4 py-2.5 shadow-card text-sm max-w-full ${tones[t.tone]}`}>
          <span>{t.text}</span>
          {t.action ? (
            <button
              type="button"
              className="font-semibold underline underline-offset-2 pointer-coarse:min-h-11 pointer-coarse:-my-3 pointer-coarse:px-2 pointer-coarse:-mx-2"
              onClick={() => {
                void t.action?.run();
                dismiss(t.id);
              }}
            >
              {t.action.label}
            </button>
          ) : null}
          {/* Aanraakvlak van 36 px, op aanraakschermen 44 px (ook bij de actieknop hierboven); de negatieve marges houden de melding even hoog en smal als zonder knoppen. */}
          <button type="button" aria-label="Sluiten" className="shrink-0 h-9 w-9 -my-2 -mr-2.5 pointer-coarse:h-11 pointer-coarse:w-11 pointer-coarse:-my-3 pointer-coarse:-mr-3 rounded-md flex items-center justify-center opacity-70 hover:opacity-100" onClick={() => dismiss(t.id)}>
            <Icon name="x" size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
